/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandingLogoRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getByDomainOrFallbackToPrimaryRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'getByDomainOrFallbackToPrimary',
  auth: 'app',
  fingerprint: 'YAWhaJbCJJdUL5lbI4wIZ5uw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByPortalIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'listByPortalId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAADZ65r3NmH35wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByBrandKitIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'listByBrandKitId',
  auth: 'app',
  fingerprint: 'ZSworqXNwC98RREq-ZqfiJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByBusinessUnitIdsRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'listByBusinessUnitIds',
  auth: 'app',
  fingerprint: '5uWxtVz2IE5FClMWPP3g0JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'm04uRS4u0Wdb5IRQHPu6sZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'kV7Ks8wcMyZb5IRQHPu6sZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const makePrimaryRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'makePrimary',
  auth: 'app',
  fingerprint: 'FUihsn5ewmtb5IRQHPu6sZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'bX34gpvBpfyOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchCreateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'batchCreate',
  auth: 'app',
  fingerprint: 'nrPuhWt8WscUq7iBVdV-j5uw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchUpdateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'batchUpdate',
  auth: 'app',
  fingerprint: 'OGLFNyiKfrDlCkwl8qprYZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchDeleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingLogoRpc',
  rpcName: 'batchDelete',
  auth: 'app',
  fingerprint: 'qNoZEKd1WdyOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};